"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckmarkListNode = void 0;
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const types_1 = require("./types");
const helpers_1 = require("../helpers");
const scrubHtml = (html) => sanitize_html_1.default(html, { allowedTags: [], allowedAttributes: {} });
const renderCheckmarkList = (rows, signerNum) => {
    const checkboxTag = `$cb${signerNum}`;
    if (!rows)
        return '';
    if (!helpers_1.isArrayOfStrings(rows)) {
        throw new Error('Variable is not of type string[]');
    }
    const inputItems = rows.reduce((acc, value) => acc.concat(`
      <div class="checkbox-item">
        <span class="checkbox-element">[${checkboxTag}]</span>
        <div class="checkbox-box-cell"><div class="checkbox-box"></div></div>
        <div class="checkbox-text">${scrubHtml(value)}</div>
      </div>
      `), '');
    return `
    <span class="checkbox-element">[def:${checkboxTag}|check|noreq|signer${signerNum}]</span>
    ${inputItems}
  `;
};
const CheckmarkListNode = (config) => ({
    id: config.id,
    type: types_1.NodeTypes.CheckmarkListNode,
    version: 1,
    render: (args) => {
        const value = helpers_1.getKey(args, config.runtimeArgs);
        return renderCheckmarkList(value, config.attributes.signerNum);
    },
    preview: () => {
        const value = config.attributes.checkboxes;
        return renderCheckmarkList(value, config.attributes.signerNum);
    },
});
exports.CheckmarkListNode = CheckmarkListNode;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hlY2ttYXJrTGlzdE5vZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL25vZGVzL2NoZWNrbWFya0xpc3ROb2RlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtFQUF5QztBQUV6QyxtQ0FBeUQ7QUFFekQsd0NBQXNEO0FBRXRELE1BQU0sU0FBUyxHQUFHLENBQUMsSUFBYSxFQUFFLEVBQUUsQ0FBQyx1QkFBWSxDQUFDLElBQUksRUFBRSxFQUFFLFdBQVcsRUFBRSxFQUFFLEVBQUUsaUJBQWlCLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztBQUVwRyxNQUFNLG1CQUFtQixHQUFHLENBQUMsSUFBYyxFQUFFLFNBQWlCLEVBQUUsRUFBRTtJQUNoRSxNQUFNLFdBQVcsR0FBRyxNQUFNLFNBQVMsRUFBRSxDQUFBO0lBQ3JDLElBQUksQ0FBQyxJQUFJO1FBQUUsT0FBTyxFQUFFLENBQUM7SUFDckIsSUFBSSxDQUFDLDBCQUFnQixDQUFDLElBQUksQ0FBQyxFQUFFO1FBQzNCLE1BQU0sSUFBSSxLQUFLLENBQUUsa0NBQWtDLENBQUMsQ0FBQztLQUN0RDtJQUNELE1BQU0sVUFBVSxHQUFHLElBQUksQ0FBQyxNQUFNLENBQzVCLENBQUMsR0FBRyxFQUFFLEtBQUssRUFBRSxFQUFFLENBQUMsR0FBRyxDQUFDLE1BQU0sQ0FDeEI7OzBDQUVvQyxXQUFXOztxQ0FFaEIsU0FBUyxDQUFDLEtBQUssQ0FBQzs7T0FFOUMsQ0FDQSxFQUNILEVBQUUsQ0FDSCxDQUFDO0lBQ0YsT0FBTzswQ0FDaUMsV0FBVyxzQkFBc0IsU0FBUztNQUM5RSxVQUFVO0dBQ2IsQ0FBQTtBQUNILENBQUMsQ0FBQztBQUVLLE1BQU0saUJBQWlCLEdBQUcsQ0FBQyxNQUEwQixFQUF5QixFQUFFLENBQUMsQ0FBQztJQUN2RixFQUFFLEVBQUUsTUFBTSxDQUFDLEVBQUU7SUFDYixJQUFJLEVBQUUsaUJBQVMsQ0FBQyxpQkFBaUI7SUFDakMsT0FBTyxFQUFFLENBQUM7SUFDVixNQUFNLEVBQUUsQ0FBQyxJQUFJLEVBQUUsRUFBRTtRQUNmLE1BQU0sS0FBSyxHQUFHLGdCQUFNLENBQUMsSUFBSSxFQUFFLE1BQU0sQ0FBQyxXQUFXLENBQUMsQ0FBQztRQUMvQyxPQUFPLG1CQUFtQixDQUFDLEtBQUssRUFBRSxNQUFNLENBQUMsVUFBVSxDQUFDLFNBQVMsQ0FBQyxDQUFDO0lBQ2pFLENBQUM7SUFDRCxPQUFPLEVBQUUsR0FBRyxFQUFFO1FBQ1osTUFBTSxLQUFLLEdBQUcsTUFBTSxDQUFDLFVBQVUsQ0FBQyxVQUFVLENBQUM7UUFDM0MsT0FBTyxtQkFBbUIsQ0FBQyxLQUFLLEVBQUUsTUFBTSxDQUFDLFVBQVUsQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUNqRSxDQUFDO0NBQ0YsQ0FBQyxDQUFDO0FBWlUsUUFBQSxpQkFBaUIscUJBWTNCIn0=